/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import types from '../actions/types';
// import { ROLES } from '../config';

const INITIAL_STATE = {
	termsVersion: []
};

export default function termsVersion(state = INITIAL_STATE, action) {
	// debugger; // eslint-disable-line no-debugger

	switch (action.type) {
		case types.GET_ALL_TERMS_VERSION:
			return { ...state, termsVersion: action.payload };
		default:
			return state;
	}
}

// Selectors
export const getTermsVersionReducer = (state) => {
	return state.termsVersion.termsVersion;
}

